/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Loader, useModal } from '@jutro/components';
import CustomLoader from 'producer-engage/src/components/CustomLoader/CustomLoader';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
// import CommonQuoteInfoMessages from "gw-capability-quoteandbind-common-react/components/CommonQuoteInfo/CommonQuoteInfo.messages";
import UWUtil from "ent-capability-quoteandbind-common-react/util/UWUtil"
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import { GatewayRenewalService } from 'twia-capability-gateway-policyrenewal';
// import { useHistory } from 'react-router-dom';
import UnderwritingWarningComponent from "ent-capability-quoteandbind-common-react/components/UnderwritingWarningComponent/UnderwritingWarningComponent";
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils';
import metadata from './QuotePage.metadata.json5';
import Offerings from '../../components/Quote/Offerings/Offerings';
import styles from './QuotePage.module.scss';
import messages from './QuotePage.messages';
import QuotePremium from '../../components/Quote/QuotePremium/QuotePremium';
import TWIAHoCoveragesUtil from '../../util/TWIAHoCoveragesUtil';

function TWIAQuotePage(props) {
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [termClausePublicID, setTermClausePublicID] = useState();
    const [isCovLoading, setIsCovLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showAdditionalFieldError, setShowAdditionalFieldError] = useState(false);
    const { showAlert, showConfirm, showModal } = useModal();
    const [offeringsVM, setOfferingsVM] = useState();
    const [continueButton, setContinueButton] = useState(false);
   //  const history = useHistory()
    const {
        wizardData: submissionVM,
        updateWizardData,
        steps,
        onResolve,
        // onReject,
        onAfterClose
    } = props;
    const QUOTE_PAGE = 'TWIAQuotePage';
    const { onValidate, isComponentValid, initialValidation } = useValidation(QUOTE_PAGE);
    const [currentOfferingVM, setCurrentOfferingVM] = useState();
    const [currentIndex, setCurrentIndex] = useState();
    const [offeredQuote, setOfferedQuote] = useState();
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const [infoBannerMsg, setInfoBannerMsg] = useState();
    const [errorsAndWarnings, setErrorsAndWarnings] = useState();
    const [infoBannerShownOnce, setInfoBannerShownOnce] = useState(false);
    const invalidClause = useRef();
    const validRef = useRef(isComponentValid)
    const breakpoint = useContext(BreakpointTrackerContext);
    const LOB_CODE = 'homeowners';
    const translator = useTranslator();
    const isEitherRenewalOrPolicyChange = TWIAJobHelper.isEitherRenewalOrPolicyChange(submissionVM.value);
    const isRenewal = TWIAJobHelper.isRenewal(submissionVM.value);
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);

    const setCoverageValidation = useCallback((isValid, clauseID) => {
        if (isValid === false) {
            invalidClause.current = clauseID;
        }

        if (onValidate) {
            onValidate(isValid, clauseID)
        }
    }, [onValidate]);

    useEffect(() => {
        validRef.current = isComponentValid
    }, [isComponentValid]);

    const checkWarningMessages = useCallback(() => {
        let issues = {};

        if (_.get(submissionVM.value, 'errorsAndWarnings') &&
            _.get(submissionVM.value, 'errorsAndWarnings.validationIssues')) {
            issues = submissionVM.value.errorsAndWarnings.validationIssues;

            // US26473 and US26474
            if (issues.issues && issues.issues.length > 0) {

                if (_.isUndefined(issues.issues[0].flowStepId) && issues.issues[0].reason.includes("Please upload")) {
                    setShowErrorMessage(true);
                    setShowErrorDescription(issues.issues[0].reason);
                    setIsLoading(false);

                }
            }

        }
        return issues;
    }, [submissionVM]);

    useEffect(() => {

        setIsLoading(true);

        const status = _.get(submissionVM, 'baseData.periodStatus.value.code') 
        || _.get(submissionVM, 'status.value.code')
        // DE18778
        const isStatusQuoted = status === 'Quoted' || status === 'Renewing'; 

        if (steps[5].visited === false && !isStatusQuoted && !isEitherRenewalOrPolicyChange) {
            // DE15964 - needs work after Address Standardization
            _.set(submissionVM, 'bindData.paymentDetails', undefined);

            const generateOffering = CustomQuoteService.saveAndGenerateOfferingTwia(submissionVM.value,
                authHeader);

            generateOffering.then((response) => {
                submissionVM.value = response;
                submissionVM.value.errorsAndWarnings = response.errorsAndWarnings
                updateWizardData(submissionVM);
                setOfferingsVM(submissionVM.lobData.homeowners.offerings)
                setIsLoading(false);

            }).catch(() => {
                ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            })
        } else if (steps[5].visited === false && !isStatusQuoted && isRenewal) {
            submissionVM.value.validationParams_TWIA = {
                validationLevel: 'default',
                validationWizardStep: 'Quote',
                skipAllValidation: false
            };

            const generateOffering = GatewayRenewalService.retrieveQuotedRenewalMessages_TWIA(submissionVM.value,
                authHeader);

            generateOffering.then((response) => {
                submissionVM.value.errorsAndWarnings = response.errorsAndWarnings
                updateWizardData(submissionVM);
                checkWarningMessages();
                setOfferingsVM(submissionVM.lobData.homeowners.offerings)
                setIsLoading(false);
            }).catch(() => {
                ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            })
        } else if (steps[5].visited === false && !isStatusQuoted && isPolicyChange){ // DE17750

            const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)[0]

            setOfferingsVM(submissionVM.lobData.homeowners.offerings)
            setOfferedQuote(() => offeredQuoteData);
            setIsLoading(false);
        }
        else {
            setContinueButton(true);

            const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)[0]

            setOfferingsVM(submissionVM.lobData.homeowners.offerings)
            setOfferedQuote(() => offeredQuoteData);
            setIsLoading(false);
        }

    }, []);

    const checkHasOnlyWarning = useCallback(() => {
        if(!showErrorMessage && !!infoBannerMsg?.includes(translator(messages.quotePageNotificationInfoBanner))) {
            return errorsAndWarnings;
        }
        return {};
    }, [showErrorMessage, infoBannerMsg, errorsAndWarnings]);

    const buildCustomQuote = useCallback((offeringCode) => {
        const offeredQuotes = submissionVM.quoteData.offeredQuotes.value;
        const lobOfferings = submissionVM.lobData.homeowners.offerings.value
        const offering = offeredQuotes.find(quote => quote.branchCode === offeringCode);
        const { coverages } = lobOfferings.find(quote => quote.branchCode === offeringCode);

        const customQuote = {
            quote: offering,
            coverages: {},
            quoteID: !isEitherRenewalOrPolicyChange ? submissionVM.quoteID.value : submissionVM.jobID.value,
            sessionUUID: submissionVM.sessionUUID.value,
            periodStart: submissionVM.baseData.periodStartDate.value,
            periodEnd: submissionVM.baseData.periodEndDate.value,
            errorsAndWarnings: checkHasOnlyWarning()
        };

        // eslint-disable-next-line security/detect-object-injection
        customQuote.coverages[LOB_CODE] = coverages;

        return customQuote;
    }, [submissionVM, showErrorMessage, infoBannerMsg, errorsAndWarnings]);

    const updateCustomQuote = useCallback(() => {
        setIsLoading(true);

        const customQuoteRequest = buildCustomQuote(currentOfferingVM.branchCode.value);
        const quoteResult = CustomQuoteService.updateCustomQuote(customQuoteRequest,
            authHeader);

        quoteResult.then((response) => {
            setErrorsAndWarnings(response.errorsAndWarnings);
            setInfoBannerMsg(null);

            if (response.errorsAndWarnings) {
                const { validationIssues } = response.errorsAndWarnings;

                const issues = validationIssues?.issues || [];
                const infoMessage = translator(messages.quotePageNotificationInfoBanner);

                const hasInfoWarning = _.some(issues, i => infoMessage.includes(i.reason));
                const hasErrors = _.some(issues, i => i.type === 'error');

                if (hasErrors) {
                    setInfoBannerShownOnce(false);
                }

                if (isEitherRenewalOrPolicyChange && hasInfoWarning) {
                    setInfoBannerMsg(infoMessage);

                    if (issues.length === 1) {
                        setShowErrorMessage(false);
                        setShowErrorDescription(null);
                    }

                    if (!infoBannerShownOnce && !hasErrors) {
                        setInfoBannerShownOnce(true);
                        setIsLoading(false);
                        return;
                    }
                }

                if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0 && hasErrors) {
                    if (_.some(validationIssues.issues, i => i.flowStepId === "HOCoverages")) {
                        setShowErrorMessage(true);
                        const coinsWaiverLimitExceedACVError = translator(messages.coinsuranceWaiverLimitExceedsACVError);
                        if (isEitherRenewalOrPolicyChange && _.some(validationIssues.issues, i => i.reason === coinsWaiverLimitExceedACVError)) {
                            setShowErrorDescription(coinsWaiverLimitExceedACVError); 
                        } else {
                            setShowErrorDescription(validationIssues.issues[0].reason);
                        }
                        setIsLoading(false);

                        return;
                    }
                    if (validationIssues.issues[0].flowStepId === "PolicyInfo") {
                        setShowErrorMessage(true);
                        setShowErrorDescription(validationIssues.issues[0].reason);
                        setIsLoading(false);

                        return;
                    }

                    // DE15570
                    if (validationIssues.issues[0].reason.includes('no coverages')) {
                        setShowErrorMessage(true);
                        setShowErrorDescription(translator(messages.noCoveragesSelected));
                        setIsLoading(false);

                        return;
                    }
                    if (validationIssues.issues[0].reason.includes('Personal Property: The coverage term')) {
                        setShowErrorMessage(true);
                        setIsLoading(false);

                        return;
                    }
                }
            }

            setContinueButton(true);

            currentOfferingVM.coverages.value = response.coverages[LOB_CODE];

            const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)
                .find((quote) => quote.branchCode === currentOfferingVM.branchCode.value);

            offeredQuoteData.premium = response.quote.premium;
            offeredQuoteData.hasBlockingUWIssues = response.quote.hasBlockingUWIssues;
            offeredQuoteData.status = response.quote.status;
            offeredQuoteData.customQuoteExtension_TWIA = response.quote.customQuoteExtension_TWIA;
            _.set(submissionVM, `lobData.homeowners.offerings[${currentIndex}].value`,
                currentOfferingVM.value);
            submissionVM.value.errorsAndWarnings = response.errorsAndWarnings;
            _.set(submissionVM.value, 'baseData.periodStatus', response.quote.status)
            updateWizardData(submissionVM);
            setOfferedQuote(() => offeredQuoteData);
            setOfferingsVM(submissionVM.lobData.homeowners.offerings);
            setShowAdditionalFieldError(false);
            setShowErrorMessage(false);
            setShowErrorDescription(null);
            setIsLoading(false);

        }).catch(() => {
            setIsLoading(false);
            ErrorPopupUtil.showQuoteErrorPopup(showAlert, true);
        })
    }, [authHeader, buildCustomQuote, currentIndex, currentOfferingVM, showAlert,
        submissionVM, translator, updateWizardData]);

    const onValueChange = useCallback(async (newValue, path, clause) => {
        if (clause) {
            setTermClausePublicID(() => clause.publicID);
        }

        const index = path.lastIndexOf(".");
        const newPath = path.substring(0, index);
        // eslint-disable-next-line no-secrets/no-secrets
        const additionalFieldsPath = 'lobData.homeowners.offerings.children[0].coverages.coveragesAdditionalFields_TWIA';
        const isGreenHouseStructureType = _.get(submissionVM, `${additionalFieldsPath}.structureType_TWIA.value.code`) === 'Greenhouse';

        // DE17690
        if(_.includes(path, 'selected') && clause?.publicID === 'TWRD_DW_Personal_Property_Cov' 
        && !newValue && isGreenHouseStructureType){          
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, `${additionalFieldsPath}.replacementCashValuePersonal_TWIA`, undefined);
            _.set(submissionVM, `${additionalFieldsPath}.actualCashValuePersonal_TWIA`, undefined);
            // eslint-disable-next-line no-secrets/no-secrets
            _.set(submissionVM, `${additionalFieldsPath}.isPersonalPropertySelected_TWIA`, false);
        }

        if (index >= 0 && !_.includes(path, 'coveragesAdditionalFields_TWIA')) {
            _.set(submissionVM, `${newPath}.updated`, true);
        }

        _.set(submissionVM, path, newValue);
        updateWizardData(submissionVM);
        await setOfferingsVM(submissionVM.lobData.homeowners.offerings);
    }, [submissionVM, updateWizardData])

    const onValueChangeAndSync = useCallback(async (newValue, path, clause, offeringVM, index) => {
        await onValueChange(newValue, path, clause);
        setShowAdditionalFieldError(true);
        setContinueButton(false); // DE16025

        // DE15701
        if (_.includes(path, 'coveragesAdditionalFields_TWIA')) {
            return;
        }

        if (!clause) {
            setIsCovLoading(() => termClausePublicID);
        } else {
            setIsCovLoading(clause.publicID);
        }

        const customQuoteRequest = buildCustomQuote(offeringVM.branchCode.value);
        const syncCoverages = CustomQuoteService.updateCustomQuoteCoverages(customQuoteRequest,
            authHeader);

        syncCoverages.then((response) => {
            setShowError(true);
            setShowAdditionalFieldError(false);
            setContinueButton(false);
            // eslint-disable-next-line security/detect-object-injection, no-param-reassign
            offeringVM.coverages.value = response.coverages[LOB_CODE];
            _.set(submissionVM, `lobData.homeowners.offerings[${index}].value`, offeringVM.value);
            submissionVM.value.errorsAndWarnings = response.errorsAndWarnings;

            const offeredQuoteData = _.get(submissionVM, `quoteData.offeredQuotes.value`)
                .find((quote) => quote.branchCode === currentOfferingVM.branchCode.value);

            offeredQuoteData.premium = response.quote.premium;
            offeredQuoteData.hasBlockingUWIssues = response.quote.hasBlockingUWIssues;
            offeredQuoteData.status = response.quote.status;
            offeredQuoteData.customQuoteExtension_TWIA = response.quote.customQuoteExtension_TWIA;
            _.set(submissionVM, `lobData.homeowners.offerings[${currentIndex}].value`,
                currentOfferingVM.value);
            updateWizardData(submissionVM);
            setOfferingsVM(submissionVM.lobData.homeowners.offerings);
            setOfferedQuote(() => offeredQuoteData);
            setIsCovLoading(null);
        }).catch(() => {
            // DE15734
            setShowError(true);
            setShowAdditionalFieldError(true);
            setIsCovLoading(null);
            setIsLoading(false);
            setContinueButton(false);

            if (path.includes('selected') && !validRef.current) {
                onValueChange(!newValue, path);
            }
        });
    }, [authHeader, buildCustomQuote, currentIndex, currentOfferingVM, onValueChange,
        submissionVM, termClausePublicID, updateWizardData]);

    // US26348
    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        // await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, showModal,translator, authHeader, setIsPrinting);     
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext'|| quoteStatus === 'Renewing'){
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const checkInfoVisible = useCallback(() => {
        if(infoBannerMsg?.includes(translator(messages.quotePageNotificationInfoBanner))) {
            return true;
        }
        const coverageData = TWIAHoCoveragesUtil.getBaseCoverageAndAdditionalFields(submissionVM);

        return TWIAHoCoveragesUtil.isStructureLimitLess80PercentRCVForTWRD(coverageData);
    }, [submissionVM, infoBannerMsg])

    const checkReplacementCostACVR = useCallback(() => {
        const coverageData = TWIAHoCoveragesUtil.getBaseCoverageAndAdditionalFields(submissionVM);

        return TWIAHoCoveragesUtil.isValuationMethodReplacementCostACVR(coverageData);
    }, [submissionVM])

    const showContinue = useCallback(() => {
        if (_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value') !== undefined) {
            return continueButton && !isLoading
                && UWUtil.premiumContinueVisibility(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))
        }

        return continueButton && !isLoading
    }, [continueButton, isLoading, submissionVM])

    const showUWWarningComponent = useCallback(() => {
        const uwIssues = _.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value')

        if ( uwIssues !== undefined) {
            const uwIssueslength = uwIssues?.filter(uw=>(uw.currentBlockingPoint !=='NonBlocking')).length > 0

            if(isRenewal && uwIssueslength ) {
                const path = `${process.env.PUBLIC_PATH}/renewal/${submissionVM.jobID.value}/summary`
                window.open(path, '_self')
            }

            if(!isRenewal) {
            return UWUtil.checkUWIssues(_.get(submissionVM, 'errorsAndWarnings.underwritingIssues.value'))
            }
        }

        return false
    }, [isRenewal, submissionVM])

    const generateOverrides = useCallback(() => {
        const offerings = _.get(submissionVM, 'lobData.homeowners.offerings.value');
        const overrides = offerings.map((_section, index) => ({
            [`offeringDetails${index}`]: {
                submissionVM,
                onValueChange,
                onValueChangeAndSync,
                isCovLoading,
                showError,
                showAdditionalFieldError,
                updateWizardData,
                onValidate,
                isComponentValid,
                setCurrentOfferingVM,
                setCurrentIndex,
                setCoverageValidation
            },
        }));

        return Object.assign({}, ...overrides);
    }, [isComponentValid, isCovLoading, onValidate, onValueChange, onValueChangeAndSync,
        setCoverageValidation, showAdditionalFieldError, showError, submissionVM,
        updateWizardData]);

    const getPremiumCardMessage = useCallback(() => {
        if (isRenewal) {
            return translator(messages.quoteRenewalPremiumCardMessage)
        } 
        
        if (isPolicyChange) {
            return translator(messages.quoteChangePremiumCardMessage)
        }

        return translator(messages.quotePremiumCardMessage)
    }, [isPolicyChange, isRenewal, translator]);

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        offerings: {
            visible: !_.isUndefined(offeringsVM),
            data: offeringsVM ? offeringsVM.children : []
        },
        premiumCard: {
            submissionVM,
            isComponentValid,
            updateCustomQuote,
            offeredQuote,
            showError, // DE15658
            showAdditionalFieldError
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription,
            isDismissable: errorDescription?.includes("Please upload"),
            type: errorDescription?.includes("Please upload") ? 'warning' : 'error' // US26473 and US26474
        },
        quotePageNotification: {
            visible: checkInfoVisible(), // Added visibility for Dwelling info message
            message:  !!infoBannerMsg?.includes(translator(messages.quotePageNotificationInfoBanner)) ? infoBannerMsg : translator(messages.quotePageNotificationDefaultText)
        },
        // US26432
        UnderwritingWarning: {
            submissionVM,
            visible: showUWWarningComponent()
        },
        // US26473 and US26474
        quotePageNotificationRenewal: {
            visible: isEitherRenewalOrPolicyChange && checkReplacementCostACVR()
        },
        quotePageInstructions: {
            content: getPremiumCardMessage()
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        },
        ...generateOverrides(),
    };

    // US26346, US26347
    const onNext = () => {
        setIsLoading(true);

        const offeredQuotes = submissionVM.quoteData.offeredQuotes.value;
        // DE15562
        const selectedQuote = offeredQuotes.find(offering => offering.branchCode === currentOfferingVM.branchCode.value);
        const jobID = !isEitherRenewalOrPolicyChange ? submissionVM.quoteID.value : submissionVM.jobID.value

        return CustomQuoteService.setSelectedVersionOnSubmission(
            jobID,
            selectedQuote.branchName,
            submissionVM.sessionUUID.value,
            authHeader
        ).then(() => {
            setIsLoading(false);

            return submissionVM

        })
    }

    const skipCondition = useCallback(
        () => {
            if (initialValidation && !_.isNull(isComponentValid)) {
                return initialValidation() && isComponentValid;
            }
            if (!(_.get(submissionVM, `quoteData.offeredQuotes.value`).length)) {
                return false;
            }
            const errorMessagesSet = checkWarningMessages();
            return initialValidation() && (_.isArray(errorMessagesSet?.issues) ? errorMessagesSet?.issues?.length === 0 : true);
        }, [checkWarningMessages, initialValidation, isComponentValid, submissionVM]
    );

    const resolvers = {
        resolveCallbackMap: {
            quotePrintDocument
        },
        resolveComponentMap: {
            offeringComponent: Offerings,
            premiumCardComponent: QuotePremium,
            UnderwritingWarningComponent,
            customLoader: CustomLoader
        },
        resolveClassNameMap: styles
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            // DE15647
            showNext={showContinue()}
            nextLabel={translator(messages.continueLabel)}
            onNext={onNext}
            // Quote Page getting skipped DE19010
            // skipWhen={skipCondition}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    showErrors={showError || showAdditionalFieldError}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIAQuotePage.propTypes = wizardProps;
export default TWIAQuotePage;
